






















































































import { Component, Ref, Vue } from 'vue-property-decorator';
import SaveButton from '@/components/App/SaveButton.vue';
import env from '@/env';
import HandleChangesInBlueprintDialog from '@/components/Dialogues/HandleChangesInBlueprintDialog.vue';
import EditAttributeDialog from '@/components/Dialogues/EditAttributeDialog.vue';
import MoveStepToOtherBlueprintDialog from '@/components/Modules/MoveStepToOtherBlueprintDialog.vue';
import axios from 'axios';
import ModuleStepList from '@/views/ModulePage/ModuleStepList.vue';
import SelectBlueprintStepDialog from '@/views/ModulePage/SelectBlueprintStepDialog.vue';
import EnvironmentSelector from '@/views/ModulePage/EnvironmentSelector.vue';
import { Module } from '@/interfaces/Module';
import { Step } from '@/interfaces/Step';
import { StepRequiresStep } from '@/interfaces/StepRequiresStep';
import { Attribute } from '@/interfaces/Attribute';
import AppSAPBadge from '@/components/App/AppSAPBadge.vue';
import { Requirement } from '@/types';
import LanguageTextInput from '@/components/App/LanguageTextInput.vue';

@Component({
  components: {
    LanguageTextInput,
    AppSAPBadge,
    EnvironmentSelector,
    SelectBlueprintStepDialog,
    ModuleStepList,
    MoveStepToOtherBlueprintDialog,
    EditAttributeDialog,
    HandleChangesInBlueprintDialog,
    SaveButton
  },
  computed: {}
})
export default class ModuleView extends Vue {
  private selectedEnvironment = 0;

  private defaultTab = 0;

  get all_attributes() {
    return this.$store.state.all_attributes;
  }

  get all_environments() {
    return this.$store.state.all_environments;
  }

  private handleMoveStep(direction: string, step: Step) {
    const stepIndex = this.module.steps.indexOf(step);
    if (stepIndex < 0) return;

    const swappingStepIndex = stepIndex + (direction === 'up' ? -1 : 1);
    if (swappingStepIndex < 0 || swappingStepIndex >= this.module.steps.length) return;

    const stepToSwapWith = this.module.steps[swappingStepIndex];
    Vue.set(this.module.steps, swappingStepIndex, step);
    Vue.set(this.module.steps, stepIndex, stepToSwapWith);
    stepToSwapWith.position = stepIndex;
    step.position = swappingStepIndex;
    this.$forceUpdate();
  }

  get selectableAttributes() {
    return this.all_attributes.filter((attribute: Attribute) => {
      const matches_blueprint = attribute.is_blueprint === this.module.is_blueprint;
      const in_scope =
        (attribute.local ? attribute.origin_id === this.module?.id : true) &&
        (attribute.global ? true : attribute.cutoverplan_id === this.module?.cutoverplan_id);
      return matches_blueprint && in_scope;
    });
  }

  private setStepRequires(stepId: number, requires: StepRequiresStep[]) {
    const step = this.module.steps.find((moduleStep: Step) => moduleStep.id === stepId);
    if (!step) return;

    step.requires = requires;
    const stepsWithThisAsRequiredBy: Step[] = this.module.steps.filter((s: Step) =>
      s.required_by.find((r: StepRequiresStep) => r.id === stepId)
    );

    for (const stepWithThisAsRequiredBy of stepsWithThisAsRequiredBy) {
      const requirement = stepWithThisAsRequiredBy.required_by.find(
        (r: StepRequiresStep) => r.id === stepId
      );
      if (!requirement) continue;
      const index = stepWithThisAsRequiredBy.required_by.indexOf(requirement);
      stepWithThisAsRequiredBy.required_by.splice(index, 1);
    }

    for (const requirement of requires) {
      const requiredStep = this.module.steps.find(
        (otherStep: Step) => otherStep.id === requirement.depending_id
      );
      if (requiredStep) {
        requiredStep.required_by.push(requirement);
      }
    }
  }

  private setStepRequiredBy(stepId: number, required_by: StepRequiresStep[]) {
    const step = this.module?.steps.find((moduleStep: Step) => moduleStep.id === stepId);
    if (!step) return;

    step.required_by = required_by;
    const stepsWithThisAsRequires: Step[] = this.module.steps.filter((s: Step) =>
      s.requires.find((r: StepRequiresStep) => r.depending_id === stepId)
    );

    for (const stepWithThisAsRequired of stepsWithThisAsRequires) {
      const requirement = stepWithThisAsRequired.requires.find(
        (r: StepRequiresStep) => r.depending_id === stepId
      );
      if (!requirement) continue;
      stepWithThisAsRequired.requires.splice(
        stepWithThisAsRequired.requires.indexOf(requirement),
        1
      );
    }

    for (const requirement of required_by) {
      const requiredStep = this.module.steps.find(
        (otherStep: Step) => otherStep.id === requirement.id
      );
      if (requiredStep) {
        requiredStep.requires.push(requirement);
      }
    }
  }

  module: Module = ({ steps: [] } as unknown) as Module;

  saving = false;

  all_steps: Step[] = [];

  changes = {};

  changesStack: any = [];

  showHandleChangesInBlueprintsDialog = false;

  showEditAttributeDialog = false;

  showMoveStepToOtherBlueprintDialog = false;

  stepToMovetoOtherBlueprint: any = {};

  id = '';

  private async addEnvironmentSpecificStep(step: Step, environmentId: number) {
    const newStepDto: Partial<Step & { is_change_of_step: number; environment_id: number }> = {
      is_change_of_step: step.id,
      environment_id: environmentId
    };

    await axios.post(`${env.backend_url}/step/create`, newStepDto);
    await this.loadEnvironmentSpecificSteps();
  }

  private async addEnvironmentSpecificStepForAll() {
    const stepsWithoutEnvironmentSpecificStep: Step[] = [];
    this.module.steps.forEach((step) => {
      const environmentSpecificStep = this.environmentSteps.find(
        (environmentStep) => environmentStep.id === step.id
      );

      if (
        environmentSpecificStep &&
        environmentSpecificStep.environments.find(
          (e) => e.environment_id === this.selectedEnvironment
        )
      )
        return;

      stepsWithoutEnvironmentSpecificStep.push(step);
    });

    stepsWithoutEnvironmentSpecificStep.forEach((step) => {
      this.addEnvironmentSpecificStep(step, this.selectedEnvironment);
    });
  }

  private environmentSteps: Step[] = [];

  private newSteps: Step[] = [];

  private async loadEnvironmentSpecificSteps(): Promise<Step[]> {
    const { data } = await axios.get(`${env.backend_url}/steps`, {
      params: {
        moduleId: this.$route.params.module_id
      }
    });

    this.environmentSteps = data;
    return this.environmentSteps;
  }

  private handleMoveStepToOtherBlueprintOpenDialog(step: Step) {
    this.showMoveStepToOtherBlueprintDialog = true;
    this.stepToMovetoOtherBlueprint = step;
  }

  async addStepBelow(aboveStep: Step) {
    const position = (aboveStep.position || 0) + 1;
    const { data: newStep } = await axios.post(`${env.backend_url}/step/create`, {
      position,
      module_id: this.module.id,
      requires: [],
      is_blueprint: this.module.is_blueprint,
      blueprint_id: null
    });

    this.addedStepIds.push(newStep.id);

    newStep.required_by = [...aboveStep.required_by];
    newStep.requires = [
      {
        step_id: newStep.id,
        depending_id: aboveStep.id,
        hidden: false
      }
    ];
    const steps = [];
    let insertPosition = 0;
    for (let i = 0; i < this.module.steps.length; i += 1) {
      const step = this.module.steps[i];
      step.position = insertPosition;
      insertPosition += 1;
      steps.push(step);
      if (position - 1 === i) {
        newStep.position = insertPosition;
        insertPosition += 1;
        steps.push(newStep);
      }
    }
    this.module.steps = steps;
    this.setStepRequiredBy(
      newStep.id,
      aboveStep.required_by.map((requirement) => ({
        ...requirement,
        depending_id: newStep.id
      }))
    );
    this.setStepRequiredBy(aboveStep.id, [
      {
        hidden: true,
        id: newStep.id,
        depending_id: aboveStep.id
      } as StepRequiresStep
    ]);
    this.newSteps.push(newStep);
  }

  private addedStepIds: number[] = [];

  private async addStep() {
    const position = this.module.steps.length;
    const is_blueprint = !!this.module?.is_blueprint;
    const { data: step }: { data: Step } = await axios.post(`${env.backend_url}/step/create`, {
      position,
      module_id: this.module.id,
      is_blueprint,
      blueprint_id: null,
      requires: [],
      informs: []
    });

    this.addedStepIds.push(step.id);
    this.module.steps.push(step);
    if (this.module.is_blueprint) {
      this.all_steps.find((s) => s.module.id === this.module.id)?.steps.push(step);
    }
    await this.$vuetify.goTo(document.body.scrollHeight);
    this.newSteps.push(step);
  }

  public async created() {
    const urlParams = window.location.search?.split('=');
    if (urlParams.length > 1) this.selectedEnvironment = +urlParams[1];

    this.loadEnvironmentSpecificSteps();
    await this.refreshModule();
  }

  private async refreshModule() {
    this.$emit('showPreloader');
    this.id = this.$route.params.module_id;
    this.$store.dispatch('refreshAllAttributes').then(() => {
      if (this.all_attributes.length > 0 && this.module?.attributes) {
        this.module?.attributes.forEach((attribute: Attribute, index: number) => {
          this.module!.attributes[index] = this.all_attributes.find(
            (attr: Attribute) => attr.id === attribute.id
          );
        });
      }
    });

    const { data: module } = await axios.get(`${env.backend_url}/module/full/${this.id}`);
    this.module = module;

    this.$emit('loadingFinished');
  }

  stepToAddRequirements: Step = {} as Step;

  showAddRequirementsToStepDialog = false;

  stepToAddRequirementsScope?: string;

  async addRequirementsToStep(step: Step, scope: string) {
    this.stepToAddRequirements = step;
    this.stepToAddRequirementsScope = scope;
    this.showAddRequirementsToStepDialog = true;
  }

  @Ref('moduleStepList')
  moduleStepList!: ModuleStepList;

  private async handleAddRequirementsToStep(step: Step | 'cancel') {
    this.showAddRequirementsToStepDialog = false;
    if (step === 'cancel') return;
    if (this.stepToAddRequirements) {
      const newRequires = step.requires
        .map((requirement: StepRequiresStep) => ({
          ...requirement,
          id: this.stepToAddRequirements?.id
        }))
        .filter(
          (requirement: StepRequiresStep) =>
            requirement.depending_id !== this.stepToAddRequirements.id
        );
      const newRequiredBy = step.required_by
        .map((requirement: StepRequiresStep) => ({
          ...requirement,
          depending_id: this.stepToAddRequirements?.id
        }))
        .filter(
          (requirement: StepRequiresStep) => requirement.id !== this.stepToAddRequirements.id
        );
      if (!this.stepToAddRequirementsScope || this.stepToAddRequirementsScope === 'requires')
        this.setStepRequires(
          this.stepToAddRequirements.id,
          Array.from(new Set([...this.stepToAddRequirements.requires, ...newRequires]))
        );
      if (!this.stepToAddRequirementsScope || this.stepToAddRequirementsScope === 'required_by')
        this.setStepRequiredBy(
          this.stepToAddRequirements.id,
          Array.from(new Set([...this.stepToAddRequirements.required_by, ...newRequiredBy]))
        );
    }
  }

  async handleMoveStepToOtherBlueprint(selectedBlueprintId: number | 'cancel') {
    this.showMoveStepToOtherBlueprintDialog = false;
    if (selectedBlueprintId === 'cancel') {
      return;
    }

    const { data: changes } = await axios.post(`${env.backend_url}/step/move`, {
      step: this.stepToMovetoOtherBlueprint,
      newBlueprintId: selectedBlueprintId
    });
    this.changesStack.push(...changes);
    if (!this.showHandleChangesInBlueprintsDialog && this.changesStack.length > 0) {
      this.showHandleChangesInBlueprintsDialog = true;
      this.changes = this.changesStack.pop();
    }

    /* this.$store.commit('removeStep', this.stepToMovetoOtherBlueprint); */
    this.module?.steps.splice(this.module.steps.indexOf(this.stepToMovetoOtherBlueprint.id), 1);
    this.module.steps.slice(
      this.module.steps.indexOf(
        this.module.steps.find(
          (step: Step) => step.id === this.stepToMovetoOtherBlueprint?.id,
          1
        ) as Step
      )
    );
    this.stepToMovetoOtherBlueprint = null;
  }

  async handleChangesInBlueprints(cancel: boolean) {
    this.showHandleChangesInBlueprintsDialog = false;
    if (!cancel) {
      await axios.post(`${env.backend_url}/module/update_blueprint_dependents`, this.changes);
    }

    this.changes = this.changesStack.pop();
    if (this.changes) {
      this.showHandleChangesInBlueprintsDialog = true;
    } else {
      await this.refreshModule();
    }
  }

  async save() {
    const changes = axios.put(`${env.backend_url}/module/${this.module?.id}`, {
      module: this.module,
      addedStepIds: this.addedStepIds
    });

    this.addedStepIds = [];

    if (this.environmentSteps) {
      await axios.post(`${env.backend_url}/module/environment-steps`, this.environmentSteps);
    }
    if ((await changes).data === 'OK') {
      return true;
    }
    this.changesStack.push(
      ...(await changes).data.filter((data: any) => data && data.dependents && data.changes_made)
    );
    if (!this.showHandleChangesInBlueprintsDialog && this.changesStack.length > 0) {
      this.showHandleChangesInBlueprintsDialog = true;
      this.changes = this.changesStack.pop();
    }
    this.$store.dispatch('refreshIdstoNameMap');
    return true;
  }
}
